<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-card">
      <div class="modal-header">
        <h3>Save to Group</h3>
        <button class="btn-close" @click="$emit('close')"><i class="fas fa-times"></i></button>
      </div>
      
      <div class="modal-body">
        
        <div class="create-group-row">
          <input 
            v-model="newGroupName" 
            placeholder="Create new group..." 
            @keyup.enter="createNewGroup"
          />
          <button class="btn-create" @click="createNewGroup" :disabled="!newGroupName">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <div class="group-list">
          <div 
            v-for="group in groupNames" 
            :key="group" 
            class="group-item" 
            @click="toggleGroup(group)"
          >
            <span class="group-name">{{ group }}</span>
            <div class="checkbox-indicator" :class="{ 'checked': isInGroup(group) }">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>

      </div>
      
      <div class="modal-footer">
        <button v-if="isFavorite" class="btn-remove-all" @click="removeAll">
          Remove from Favorites
        </button>
        <button class="btn-done" @click="$emit('close')">Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import favService from '../services/favorites';

export default {
  props: ['characterId'],
  data() {
    return {
      allGroups: {},
      newGroupName: '',
      itemGroups: []
    };
  },
  computed: {
    groupNames() {
      return Object.keys(this.allGroups).sort();
    },
    isFavorite() {
      return this.itemGroups.length > 0;
    }
  },
  methods: {
    loadData() {
      this.allGroups = favService.getGroups();
      this.itemGroups = favService.getItemGroups(this.characterId);
    },
    isInGroup(group) {
      return this.itemGroups.includes(group);
    },
    toggleGroup(group) {
      if (this.isInGroup(group)) {
        favService.removeFromGroup(this.characterId, group);
      } else {
        favService.addToGroup(this.characterId, group);
      }
      // Refresh local data
      this.loadData();
      this.$emit('change'); // Notify parent to update star icon
    },
    createNewGroup() {
      if (!this.newGroupName.trim()) return;
      favService.createGroup(this.newGroupName);
      // Automatically add item to the new group
      favService.addToGroup(this.characterId, this.newGroupName);
      this.newGroupName = '';
      this.loadData();
      this.$emit('change');
    },
    removeAll() {
      favService.removeFromAll(this.characterId);
      this.loadData();
      this.$emit('change');
      this.$emit('close');
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center; z-index: 2000; }
.modal-card { background: white; width: 350px; border-radius: 8px; box-shadow: 0 10px 25px rgba(0,0,0,0.3); overflow: hidden; display: flex; flex-direction: column; }
.modal-header { padding: 15px; background: #f8f9fa; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 16px; }
.btn-close { border: none; background: none; font-size: 16px; cursor: pointer; color: #666; }
.modal-body { padding: 15px; max-height: 400px; overflow-y: auto; }

.create-group-row { display: flex; gap: 10px; margin-bottom: 15px; }
.create-group-row input { flex: 1; padding: 8px; border: 1px solid #ddd; border-radius: 4px; }
.btn-create { background: var(--accent-color); color: white; border: none; border-radius: 4px; width: 35px; cursor: pointer; }
.btn-create:disabled { background: #ccc; cursor: default; }

.group-list { display: flex; flex-direction: column; gap: 5px; }
.group-item { display: flex; justify-content: space-between; align-items: center; padding: 10px; border-radius: 4px; cursor: pointer; transition: background 0.2s; border: 1px solid transparent; }
.group-item:hover { background: #f0f0f0; }
.checkbox-indicator { width: 20px; height: 20px; border: 2px solid #ddd; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white; font-size: 12px; }
.checkbox-indicator.checked { background: var(--accent-color); border-color: var(--accent-color); }

.modal-footer { padding: 15px; background: #f8f9fa; border-top: 1px solid #eee; display: flex; justify-content: space-between; }
.btn-remove-all { background: transparent; color: #e74c3c; border: none; font-size: 12px; cursor: pointer; text-decoration: underline; }
.btn-done { background: #333; color: white; padding: 6px 16px; border-radius: 4px; border: none; cursor: pointer; }
</style>